// extracted by mini-css-extract-plugin
export default {"digitalMenuPanelContainer":"LocationPanelDM_digitalMenuPanelContainer__MUa9V"};